import http from "./axios";
import { downloadFile, handleError } from "./http-utils.service";

export const downloadLetterCertificateFile = async (
  courseId: number,
  type: string,
) => {
  const name =
    type === "certificate"
      ? "SEABC Certificate.pdf"
      : "SEABC Completion Letter.pdf";
  try {
    const response = await http.get<Blob>(`/courses/${courseId}/${type}`, {
      responseType: "blob",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
      },
    });
    downloadFile(response.data, name);
    return response.data;
  } catch (e) {
    throw handleError(e);
  }
};
